{
  "INTEGRATION_SETTINGS": {
    "SHOPIFY": {
      "DELETE": {
        "TITLE": "Delete Shopify Integration",
        "MESSAGE": "Are you sure you want to delete the Shopify integration?"
      },
      "STORE_URL": {
        "TITLE": "Connect Shopify Store",
        "LABEL": "Store URL",
        "PLACEHOLDER": "your-store.myshopify.com",
        "HELP": "Enter your Shopify store's myshopify.com URL",
        "CANCEL": "Zrušit",
        "SUBMIT": "Connect Store"
      },
      "ERROR": "There was an error connecting to Shopify. Please try again or contact support if the issue persists."
    },
    "HEADER": "Integrace",
    "DESCRIPTION": "Kontaktní centrum se integruje s více nástroji a službami pro zlepšení efektivity vašeho týmu. Prozkoumejte níže uvedený seznam a nakonfigurujte své oblíbené aplikace.",
    "LEARN_MORE": "Další informace o integracích",
    "LOADING": "Načítání integrací",
    "CAPTAIN": {
      "DISABLED": "Captain není povolen ve vašem účtu.",
      "CLICK_HERE_TO_CONFIGURE": "Klikněte zde pro konfiguraci",
      "LOADING_CONSOLE": "Načítání Captain konzole...",
      "FAILED_TO_LOAD_CONSOLE": "Nepodařilo se načíst Captain konzoli. Obnovte stránku a zkuste to znovu."
    },
    "WEBHOOK": {
      "SUBSCRIBED_EVENTS": "Přihlášené události",
      "LEARN_MORE": "Další informace o webhookách",
      "FORM": {
        "CANCEL": "Zrušit",
        "DESC": "Události webhooku vám poskytují reálné informace o tom, co se děje ve vašem účtu. Zadejte prosím platnou URL pro nastavení hovoru.",
        "SUBSCRIPTIONS": {
          "LABEL": "Události",
          "EVENTS": {
            "INBOX_CREATED": "Schránka vytvořena",
            "CONVERSATION_CREATED": "Konverzace vytvořena",
            "CONVERSATION_STATUS_CHANGED": "Stav konverzace změněn",
            "CONVERSATION_UPDATED": "Konverzace aktualizována",
            "MESSAGE_CREATED": "Zpráva vytvořena",
            "MESSAGE_UPDATED": "Zpráva aktualizována",
            "WEBWIDGET_TRIGGERED": "Živý chat widget otevřen uživatelem",
            "CONTACT_CREATED": "Kontakt vytvořen",
            "CONTACT_UPDATED": "Kontakt aktualizován",
            "JARABOT_EVENT": "Interní události"
          }
        },
        "END_POINT": {
          "LABEL": "URL webového háčku",
          "PLACEHOLDER": "Example: {webhookExampleURL}",
          "ERROR": "Zadejte prosím platnou URL"
        },
        "EDIT_SUBMIT": "Aktualizovat webhook",
        "ADD_SUBMIT": "Vytvořit webhook"
      },
      "TITLE": "Webhook",
      "CONFIGURE": "Konfigurace",
      "HEADER": "Nastavení webhooku",
      "HEADER_BTN_TXT": "Přidat nový webhook",
      "LOADING": "Načítání připojených webhooků",
      "SEARCH_404": "Neexistují žádné položky odpovídající tomuto dotazu",
      "SIDEBAR_TXT": "<p><b>Webové háčky</b> </p> <p>jsou HTTP zpětné volání, které lze definovat pro každý účet. Jsou spouštěny událostmi, jako je vytváření zpráv. Můžete vytvořit více než jeden webhook pro tento účet. <br /><br /> Pro vytvoření webového háčku <b></b>klikněte na tlačítko <b>Přidat nový webhook</b> . Kliknutím na tlačítko Odstranit můžete také odstranit jakýkoli existující webhook.</p>",
      "LIST": {
        "404": "Pro tento účet nejsou nakonfigurovány žádné webhooky.",
        "TITLE": "Spravovat webové háčky",
        "TABLE_HEADER": {
          "WEBHOOK_ENDPOINT": "Koncový bod webhooku",
          "ACTIONS": "Akce"
        }
      },
      "EDIT": {
        "BUTTON_TEXT": "Upravit",
        "TITLE": "Upravit webhook",
        "API": {
          "SUCCESS_MESSAGE": "Konfigurace webhooku úspěšně aktualizována",
          "ERROR_MESSAGE": "Nelze se připojit k chat serveru, opakujte akci později"
        }
      },
      "ADD": {
        "CANCEL": "Zrušit",
        "TITLE": "Přidat nový webhook",
        "API": {
          "SUCCESS_MESSAGE": "Konfigurace webhooku úspěšně přidána",
          "ERROR_MESSAGE": "Nelze se připojit k chat serveru, opakujte akci později"
        }
      },
      "DELETE": {
        "BUTTON_TEXT": "Vymazat",
        "API": {
          "SUCCESS_MESSAGE": "Webhook byl úspěšně odstraněn",
          "ERROR_MESSAGE": "Nelze se připojit k chat serveru, opakujte akci později"
        },
        "CONFIRM": {
          "TITLE": "Potvrdit odstranění",
          "MESSAGE": "Opravdu chcete odstranit webhook? ({webhookURL})",
          "YES": "Ano, odstranit ",
          "NO": "Ne, ponechat"
        }
      },
      "DISABLED_BADGE": "Zakázáno",
      "DISABLED_REASON": "Automaticky zakázáno po {count} po sobě jdoucích selháních. Poslední chyba: {error}",
      "ENABLE": {
        "BUTTON_TEXT": "Povolit",
        "API": {
          "SUCCESS_MESSAGE": "Webhook byl úspěšně povolen",
          "ERROR_MESSAGE": "Webhook nelze povolit, zkuste to znovu později"
        }
      }
    },
    "SLACK": {
      "DELETE": "Vymazat",
      "DELETE_CONFIRMATION": {
        "TITLE": "Odstranit integraci",
        "MESSAGE": "Opravdu chcete odstranit integraci? Dojde ke ztrátě přístupu ke konverzacím na vašem pracovišti Slack."
      },
      "HELP_TEXT": {
        "TITLE": "Používání integrace Slack",
        "BODY": "With this integration, all of your incoming conversations will be synced to the ***{selectedChannelName}*** channel in your Slack workspace. You can manage all your customer conversations right within the channel and never miss a message.\n\nHere are the main features of the integration:\n\n**Respond to conversations from within Slack:** To respond to a conversation in the ***{selectedChannelName}*** Slack channel, simply type out your message and send it as a thread. This will create a response back to the customer through Contact Center. It's that simple!\n\n **Create private notes:** If you want to create private notes instead of replies, start your message with ***`note:`***. This ensures that your message is kept private and won't be visible to the customer.\n\n**Associate an agent profile:** If the person who replied on Slack has an agent profile in Contact Center under the same email, the replies will be associated with that agent profile automatically. This means you can easily track who said what and when. On the other hand, when the replier doesn't have an associated agent profile, the replies will appear from the bot profile to the customer.",
        "SELECTED": "vybráno"
      },
      "SELECT_CHANNEL": {
        "OPTION_LABEL": "Vybrat kanál",
        "UPDATE": "Aktualizovat",
        "BUTTON_TEXT": "Připojit kanál",
        "DESCRIPTION": "Vaše pracoviště Slack je nyní propojeno s kontaktním centrem. Integrace je však aktuálně neaktivní. Chcete-li aktivovat integraci a připojit kanál, klikněte na tlačítko níže.\n\n**Poznámka:** Pokud se pokoušíte připojit soukromý kanál, přidejte naši aplikaci do kanálu Slack před provedením tohoto kroku.",
        "ATTENTION_REQUIRED": "Vyžadována pozornost",
        "EXPIRED": "Vaše integrace Slack vypršela. Chcete-li nadále přijímat zprávy na Slacku, odstraňte integraci a znovu připojte svůj pracovní prostor."
      },
      "UPDATE_ERROR": "Při aktualizaci integrace došlo k chybě, zkuste to prosím znovu",
      "UPDATE_SUCCESS": "Kanál byl úspěšně připojen",
      "FAILED_TO_FETCH_CHANNELS": "Při načítání kanálů ze Slacku došlo k chybě, zkuste to prosím znovu"
    },
    "OPEN_AI": {
      "AI_ASSIST": "AI asistent",
      "WITH_AI": " {option} s AI ",
      "OPTIONS": {
        "REPLY_SUGGESTION": "Návrh odpovědi",
        "SUMMARIZE": "Shrnutí",
        "REPHRASE": "Vylepšit psaní",
        "FIX_SPELLING_GRAMMAR": "Opravit pravopis a gramatiku",
        "SHORTEN": "Zkrátit",
        "EXPAND": "Rozšířit",
        "MAKE_FRIENDLY": "Změnit tón zprávy na přátelský",
        "MAKE_FORMAL": "Použít formální tón",
        "SIMPLIFY": "Zjednodušit",
        "TRANSLATE": "Přeložit",
        "TRANSLATE_TO_MAJORITY_LANGUAGE": "Sjednotit jazyk zprávy"
      },
      "ASSISTANCE_MODAL": {
        "DRAFT_TITLE": "Koncept obsahu",
        "GENERATED_TITLE": "Vygenerovaný obsah",
        "AI_WRITING": "AI píše",
        "BUTTONS": {
          "APPLY": "Použít tento návrh",
          "CANCEL": "Zrušit"
        }
      },
      "CTA_MODAL": {
        "TITLE": "Integrovat s OpenAI",
        "DESC": "Přineste pokročilé funkce AI do vašeho dashboardu pomocí modelů GPT od OpenAI. Pro začátek zadejte API klíč z vašeho účtu OpenAI.",
        "KEY_PLACEHOLDER": "Zadejte váš OpenAI API klíč",
        "BUTTONS": {
          "NEED_HELP": "Potřebujete pomoc?",
          "DISMISS": "Zrušit",
          "FINISH": "Dokončit nastavení"
        },
        "DISMISS_MESSAGE": "Integraci OpenAI můžete nastavit později kdykoliv budete chtít.",
        "SUCCESS_MESSAGE": "Integrace OpenAI byla úspěšně nastavena"
      },
      "TITLE": "Vylepšit pomocí AI",
      "SUMMARY_TITLE": "Shrnutí pomocí AI",
      "REPLY_TITLE": "Návrh odpovědi pomocí AI",
      "SUBTITLE": "Vylepšená odpověď bude vygenerována pomocí AI na základě vašeho současného konceptu.",
      "TONE": {
        "TITLE": "Tón",
        "OPTIONS": {
          "PROFESSIONAL": "Profesionální",
          "FRIENDLY": "Přátelský"
        }
      },
      "BUTTONS": {
        "GENERATE": "Generovat",
        "GENERATING": "Generuji...",
        "CANCEL": "Zrušit"
      },
      "GENERATE_ERROR": "Při zpracování obsahu došlo k chybě, zkuste to prosím znovu"
    },
    "DELETE": {
      "BUTTON_TEXT": "Vymazat",
      "API": {
        "SUCCESS_MESSAGE": "Integrace úspěšně odstraněna"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Připojit"
    },
    "DASHBOARD_APPS": {
      "TITLE": "Dashboard Apps",
      "HEADER_BTN_TXT": "Add a new dashboard app",
      "SIDEBAR_TXT": "<p><b>Dashboard Apps</b></p><p>Dashboard Apps allow organizations to embed an application inside the Contact Center dashboard to provide the context for customer support agents. This feature allows you to create an application independently and embed that inside the dashboard to provide user information, their orders, or their previous payment history.</p><p>When you embed your application using the dashboard in Contact Center, your application will get the context of the conversation and contact as a window event. Implement a listener for the message event on your page to receive the context.</p><p>To add a new dashboard app, click on the button 'Add a new dashboard app'.</p>",
      "DESCRIPTION": "Dashboard Apps allow organizations to embed an application inside the dashboard to provide the context for customer support agents. This feature allows you to create an application independently and embed that to provide user information, their orders, or their previous payment history.",
      "LEARN_MORE": "Learn more about Dashboard Apps",
      "LIST": {
        "404": "V tomto účtu zatím nejsou nakonfigurovány žádné aplikace dashboardu",
        "LOADING": "Načítání aplikací dashboardu...",
        "TABLE_HEADER": {
          "NAME": "Název",
          "ENDPOINT": "Endpoint"
        },
        "EDIT_TOOLTIP": "Edit app",
        "DELETE_TOOLTIP": "Delete app"
      },
      "FORM": {
        "TITLE_LABEL": "Název",
        "TITLE_PLACEHOLDER": "Zadejte název pro vaši aplikaci dashboardu",
        "TITLE_ERROR": "Název pro aplikaci dashboardu je povinný",
        "URL_LABEL": "Endpoint",
        "URL_PLACEHOLDER": "Zadejte URL endpoint, kde je vaše aplikace hostována",
        "URL_ERROR": "Platná URL je povinná"
      },
      "CREATE": {
        "HEADER": "Přidat novou aplikaci dashboardu",
        "FORM_SUBMIT": "Odeslat",
        "FORM_CANCEL": "Zrušit",
        "API_SUCCESS": "Aplikace dashboardu byla úspěšně nakonfigurována",
        "API_ERROR": "Nemohli jsme vytvořit aplikaci. Zkuste to prosím později"
      },
      "UPDATE": {
        "HEADER": "Upravit aplikaci dashboardu",
        "FORM_SUBMIT": "Aktualizovat",
        "FORM_CANCEL": "Zrušit",
        "API_SUCCESS": "Aplikace dashboardu byla úspěšně aktualizována",
        "API_ERROR": "Nemohli jsme aktualizovat aplikaci. Zkuste to prosím později"
      },
      "DELETE": {
        "CONFIRM_YES": "Ano, odstranit",
        "CONFIRM_NO": "Ne, ponechat",
        "TITLE": "Potvrdit odstranění",
        "MESSAGE": "Opravdu chcete odstranit aplikaci - {appName}?",
        "API_SUCCESS": "Aplikace dashboardu byla úspěšně odstraněna",
        "API_ERROR": "Nemohli jsme odstranit aplikaci. Zkuste to prosím později"
      }
    },
    "LINEAR": {
      "ADD_OR_LINK_BUTTON": "Vytvořit/Propojit Linear problém",
      "LOADING": "Načítání linear problémů...",
      "LOADING_ERROR": "Při načítání linear problémů došlo k chybě, zkuste to prosím znovu",
      "CREATE": "Vytvořit",
      "LINK": {
        "SEARCH": "Hledat problémy",
        "SELECT": "Vybrat problém",
        "TITLE": "Odkaz",
        "EMPTY_LIST": "Nebyly nalezeny žádné linear problémy",
        "LOADING": "Načítání",
        "ERROR": "Při načítání linear problémů došlo k chybě, zkuste to prosím znovu",
        "LINK_SUCCESS": "Problém byl úspěšně propojen",
        "LINK_ERROR": "Při propojování problému došlo k chybě, zkuste to prosím znovu",
        "LINK_TITLE": "Konverzace (%<conversationId>s) s {name}"
      },
      "ADD_OR_LINK": {
        "TITLE": "Vytvořit/propojit linear problém",
        "DESCRIPTION": "Vytvářejte Linear problémy z konverzací nebo propojte existující pro bezproblémové sledování.",
        "FORM": {
          "TITLE": {
            "LABEL": "Název",
            "PLACEHOLDER": "Zadejte název",
            "REQUIRED_ERROR": "Název je povinný"
          },
          "DESCRIPTION": {
            "LABEL": "Popis",
            "PLACEHOLDER": "Zadejte popis"
          },
          "TEAM": {
            "LABEL": "Tým",
            "PLACEHOLDER": "Vybrat tým",
            "SEARCH": "Hledat tým",
            "REQUIRED_ERROR": "Tým je povinný"
          },
          "ASSIGNEE": {
            "LABEL": "Přiřazeno",
            "PLACEHOLDER": "Vybrat přiřazenou osobu",
            "SEARCH": "Hledat přiřazenou osobu"
          },
          "PRIORITY": {
            "LABEL": "Priorita",
            "PLACEHOLDER": "Vybrat prioritu",
            "SEARCH": "Hledat prioritu"
          },
          "LABEL": {
            "LABEL": "Štítek",
            "PLACEHOLDER": "Vybrat štítek",
            "SEARCH": "Hledat štítek"
          },
          "STATUS": {
            "LABEL": "Stav",
            "PLACEHOLDER": "Vybrat stav",
            "SEARCH": "Hledat stav"
          },
          "PROJECT": {
            "LABEL": "Projekt",
            "PLACEHOLDER": "Vybrat projekt",
            "SEARCH": "Hledat projekt"
          }
        },
        "CREATE": "Vytvořit",
        "CANCEL": "Zrušit",
        "CREATE_SUCCESS": "Problém byl úspěšně vytvořen",
        "CREATE_ERROR": "Při vytváření problému došlo k chybě, zkuste to prosím znovu",
        "LOADING_TEAM_ERROR": "Při načítání týmů došlo k chybě, zkuste to prosím znovu",
        "LOADING_TEAM_ENTITIES_ERROR": "Při načítání entit týmu došlo k chybě, zkuste to prosím znovu"
      },
      "ISSUE": {
        "STATUS": "Stav",
        "PRIORITY": "Priorita",
        "ASSIGNEE": "Přiřazeno",
        "LABELS": "Štítky",
        "CREATED_AT": "Vytvořeno {createdAt}"
      },
      "UNLINK": {
        "TITLE": "Odpojit",
        "SUCCESS": "Problém byl úspěšně odpojen",
        "ERROR": "Při odpojování problému došlo k chybě, zkuste to prosím znovu"
      },
      "DELETE": {
        "TITLE": "Are you sure you want to delete the integration?",
        "MESSAGE": "Are you sure you want to delete the integration?",
        "CONFIRM": "Yes, delete",
        "CANCEL": "Zrušit"
      }
    }
  },
  "CAPTAIN": {
    "NAME": "Captain",
    "HEADER_KNOW_MORE": "Zjistit více",
    "COPILOT": {
      "SEND_MESSAGE": "Napište zprávu...",
      "EMPTY_MESSAGE": "Při generování odpovědi došlo k chybě. Zkuste to prosím znovu.",
      "LOADER": "Captain přemýšlí",
      "YOU": "Vy",
      "USE": "Použít",
      "RESET": "Obnovit",
      "SELECT_ASSISTANT": "Vybrat asistenta"
    },
    "PAYWALL": {
      "TITLE": "Pro použití Captain AI proveďte upgrade",
      "AVAILABLE_ON": "Captain není dostupný v bezplatném plánu.",
      "UPGRADE_PROMPT": "Upgradujte svůj plán, abyste získali přístup k našim asistentům, copilotu a dalším funkcím.",
      "UPGRADE_NOW": "Upgradovat nyní",
      "CANCEL_ANYTIME": "Svůj plán můžete kdykoli změnit nebo zrušit"
    },
    "ENTERPRISE_PAYWALL": {
      "AVAILABLE_ON": "Funkce Captain AI je dostupná pouze v placeném plánu.",
      "UPGRADE_PROMPT": "Upgradujte svůj plán, abyste získali přístup k našim asistentům, copilotu a dalším funkcím.",
      "ASK_ADMIN": "Pro upgrade kontaktujte prosím svého administrátora."
    },
    "BANNER": {
      "RESPONSES": "Využili jste více než 80 % svého limitu odpovědí. Pro další používání Captain AI proveďte upgrade.",
      "DOCUMENTS": "Byl dosažen limit dokumentů. Pro další používání Captain AI proveďte upgrade."
    },
    "FORM": {
      "CANCEL": "Zrušit",
      "CREATE": "Vytvořit",
      "EDIT": "Aktualizovat"
    },
    "ASSISTANTS": {
      "HEADER": "Asistenti",
      "ADD_NEW": "Vytvořit nového asistenta",
      "DELETE": {
        "TITLE": "Opravdu chcete odstranit asistenta?",
        "DESCRIPTION": "Tato akce je nevratná. Odstraněním tohoto asistenta ho odeberete ze všech připojených schránek a trvale smažete veškeré vygenerované znalosti.",
        "CONFIRM": "Ano, odstranit",
        "SUCCESS_MESSAGE": "Asistent byl úspěšně odstraněn",
        "ERROR_MESSAGE": "Při odstraňování asistenta došlo k chybě, zkuste to prosím znovu."
      },
      "FORM_DESCRIPTION": "Níže vyplňte údaje pro pojmenování asistenta, popis jeho účelu a určení produktu, který bude podporovat.",
      "CREATE": {
        "TITLE": "Vytvořit asistenta",
        "SUCCESS_MESSAGE": "Asistent byl úspěšně vytvořen",
        "ERROR_MESSAGE": "Při vytváření asistenta došlo k chybě, zkuste to prosím znovu."
      },
      "FORM": {
        "NAME": {
          "LABEL": "Název asistenta",
          "PLACEHOLDER": "Zadejte název asistenta",
          "ERROR": "Zadejte prosím název asistenta"
        },
        "DESCRIPTION": {
          "LABEL": "Popis asistenta",
          "PLACEHOLDER": "Popište, jak a kde bude tento asistent používán",
          "ERROR": "Popis je povinný"
        },
        "PRODUCT_NAME": {
          "LABEL": "Název produktu",
          "PLACEHOLDER": "Zadejte název produktu, pro který je tento asistent určen",
          "ERROR": "Název produktu je povinný"
        },
        "FEATURES": {
          "TITLE": "Funkce",
          "ALLOW_CONVERSATION_FAQS": "Generovat FAQs z vyřešených konverzací",
          "ALLOW_MEMORIES": "Zaznamenávat klíčové detaily jako vzpomínky ze zákaznických interakcí."
        }
      },
      "EDIT": {
        "TITLE": "Aktualizovat asistenta",
        "SUCCESS_MESSAGE": "Asistent byl úspěšně aktualizován",
        "ERROR_MESSAGE": "Při aktualizaci asistenta došlo k chybě, zkuste to prosím znovu."
      },
      "OPTIONS": {
        "EDIT_ASSISTANT": "Upravit asistenta",
        "DELETE_ASSISTANT": "Odstranit asistenta",
        "VIEW_CONNECTED_INBOXES": "Zobrazit připojené schránky"
      },
      "EMPTY_STATE": {
        "TITLE": "Nejsou k dispozici žádní asistenti",
        "SUBTITLE": "Vytvořte asistenta, který bude poskytovat rychlé a přesné odpovědi vašim uživatelům. Může se učit z vašich článků nápovědy a předchozích konverzací.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain Asistent",
          "NOTE": "Captain Asistent komunikuje přímo se zákazníky, učí se z vašich dokumentů nápovědy a předchozích konverzací a poskytuje okamžité a přesné odpovědi. Řeší počáteční dotazy a poskytuje rychlá řešení, než je v případě potřeby  předá agentovi."
        }
      }
    },
    "DOCUMENTS": {
      "HEADER": "Dokumenty",
      "ADD_NEW": "Vytvořit nový dokument",
      "RELATED_RESPONSES": {
        "TITLE": "Související FAQs",
        "DESCRIPTION": "Tyto FAQs jsou generovány přímo z dokumentu."
      },
      "FORM_DESCRIPTION": "Zadejte URL dokumentu, který chcete přidat jako zdroj znalostí, a vyberte asistenta, ke kterému má být přiřazen.",
      "CREATE": {
        "TITLE": "Přidat dokument",
        "SUCCESS_MESSAGE": "Dokument byl úspěšně vytvořen",
        "ERROR_MESSAGE": "Při vytváření dokumentu došlo k chybě, zkuste to prosím znovu."
      },
      "FORM": {
        "URL": {
          "LABEL": "URL",
          "PLACEHOLDER": "Zadejte URL dokumentu",
          "ERROR": "Zadejte prosím platnou URL dokumentu"
        },
        "ASSISTANT": {
          "LABEL": "Asistent",
          "PLACEHOLDER": "Vybrat asistenta",
          "ERROR": "Asistent je povinný"
        }
      },
      "DELETE": {
        "TITLE": "Opravdu chcete odstranit dokument?",
        "DESCRIPTION": "Tato akce je nevratná. Odstraněním tohoto dokumentu trvale smažete veškeré vygenerované znalosti.",
        "CONFIRM": "Ano, odstranit",
        "SUCCESS_MESSAGE": "Dokument byl úspěšně odstraněn",
        "ERROR_MESSAGE": "Při odstraňování dokumentu došlo k chybě, zkuste to prosím znovu."
      },
      "OPTIONS": {
        "VIEW_RELATED_RESPONSES": "Zobrazit související odpovědi",
        "DELETE_DOCUMENT": "Odstranit dokument"
      },
      "EMPTY_STATE": {
        "TITLE": "Nejsou k dispozici žádné dokumenty",
        "SUBTITLE": "Dokumenty používá váš asistent ke generování FAQs. Dokumenty můžete importovat, abyste asistentovi poskytli kontext.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain Dokument",
          "NOTE": "Dokument v Captain slouží asistentovi jako zdroj znalostí. Propojením centra nápovědy nebo návodů dokáže Captain analyzovat obsah a poskytovat přesné odpovědi na dotazy zákazníků."
        }
      }
    },
    "RESPONSES": {
      "HEADER": "FAQs",
      "ADD_NEW": "Vytvořit nové FAQ",
      "DOCUMENTABLE": {
        "CONVERSATION": "Konverzace #{id}"
      },
      "SELECTED": "{count} vybráno",
      "BULK_APPROVE_BUTTON": "Schválit",
      "BULK_DELETE_BUTTON": "Vymazat",
      "BULK_APPROVE": {
        "SUCCESS_MESSAGE": "FAQs byla úspěšně schválena",
        "ERROR_MESSAGE": "Při schvalování FAQs došlo k chybě, zkuste to prosím znovu."
      },
      "BULK_DELETE": {
        "TITLE": "Odstranit FAQs?",
        "DESCRIPTION": "Opravdu chcete odstranit vybrané FAQs? Tuto akci nelze vrátit zpět.",
        "CONFIRM": "Ano, odstranit vše",
        "SUCCESS_MESSAGE": "FAQs byla úspěšně odstraněna",
        "ERROR_MESSAGE": "Při odstraňování FAQs došlo k chybě, zkuste to prosím znovu."
      },
      "DELETE": {
        "TITLE": "Opravdu chcete odstranit FAQ?",
        "DESCRIPTION": "",
        "CONFIRM": "Ano, odstranit",
        "SUCCESS_MESSAGE": "FAQ bylo úspěšně odstraněno",
        "ERROR_MESSAGE": "Při odstraňování FAQ došlo k chybě, zkuste to prosím znovu."
      },
      "FILTER": {
        "ASSISTANT": "Asistent: {selected}",
        "STATUS": "Stav: {selected}",
        "ALL_ASSISTANTS": "Vše"
      },
      "STATUS": {
        "TITLE": "Stav",
        "PENDING": "Čekající",
        "APPROVED": "Schválené",
        "ALL": "Vše"
      },
      "FORM_DESCRIPTION": "Přidejte otázku a odpovídající odpověď do znalostní báze a vyberte asistenta, ke kterému má být přiřazena.",
      "CREATE": {
        "TITLE": "Přidat FAQ",
        "SUCCESS_MESSAGE": "Odpověď byla úspěšně přidána.",
        "ERROR_MESSAGE": "Při přidávání odpovědi došlo k chybě. Zkuste to prosím znovu."
      },
      "FORM": {
        "QUESTION": {
          "LABEL": "Otázka",
          "PLACEHOLDER": "Zadejte otázku zde",
          "ERROR": "Zadejte prosím platnou otázku."
        },
        "ANSWER": {
          "LABEL": "Odpověď",
          "PLACEHOLDER": "Zadejte odpověď zde",
          "ERROR": "Zadejte prosím platnou odpověď."
        },
        "ASSISTANT": {
          "LABEL": "Asistent",
          "PLACEHOLDER": "Vyberte asistenta",
          "ERROR": "Vyberte prosím asistenta."
        }
      },
      "EDIT": {
        "TITLE": "Aktualizovat FAQ",
        "SUCCESS_MESSAGE": "FAQ bylo úspěšně aktualizováno",
        "ERROR_MESSAGE": "Při aktualizaci FAQ došlo k chybě, zkuste to prosím znovu",
        "APPROVE_SUCCESS_MESSAGE": "FAQ bylo označeno jako schválené"
      },
      "OPTIONS": {
        "APPROVE": "Označit jako schválené",
        "EDIT_RESPONSE": "Upravit FAQ",
        "DELETE_RESPONSE": "Odstranit FAQ"
      },
      "EMPTY_STATE": {
        "TITLE": "Nebyla nalezena žádná FAQs",
        "SUBTITLE": "FAQs pomáhají vašemu asistentovi poskytovat rychlé a přesné odpovědi na otázky vašich zákazníků. Mohou být generována automaticky z vašeho obsahu nebo přidána ručně.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain FAQ",
          "NOTE": "Captain FAQs zjišťuje časté otázky zákazníků — ať už chybí ve vaší znalostní bázi, nebo se často opakují — a generuje relevantní FAQs pro zlepšení podpory. Každý návrh můžete zkontrolovat a rozhodnout, zda jej schválíte, nebo zamítnete."
        }
      }
    },
    "INBOXES": {
      "HEADER": "Připojené schránky",
      "ADD_NEW": "Připojit novou schránku",
      "OPTIONS": {
        "DISCONNECT": "Odpojit"
      },
      "DELETE": {
        "TITLE": "Opravdu chcete odpojit schránku?",
        "DESCRIPTION": "",
        "CONFIRM": "Ano, odstranit",
        "SUCCESS_MESSAGE": "Schránka byla úspěšně odpojena.",
        "ERROR_MESSAGE": "Při odpojování schránky došlo k chybě, zkuste to prosím znovu."
      },
      "FORM_DESCRIPTION": "Vyberte schránku, kterou chcete propojit s asistentem.",
      "CREATE": {
        "TITLE": "Připojit schránku",
        "SUCCESS_MESSAGE": "Schránka byla úspěšně připojena.",
        "ERROR_MESSAGE": "Při připojování schránky došlo k chybě. Zkuste to prosím znovu."
      },
      "FORM": {
        "INBOX": {
          "LABEL": "Schránka",
          "PLACEHOLDER": "Vyberte schránku pro nasazení asistenta.",
          "ERROR": "Výběr schránky je povinný."
        }
      },
      "EMPTY_STATE": {
        "TITLE": "Žádné připojené schránky",
        "SUBTITLE": "Připojení schránky umožňuje asistentovi zpracovat úvodní dotazy vašich zákazníků, než je předá vám."
      }
    }
  }
}
